import { Routes, RouterModule } from "@angular/router";
import { AuthguardService } from "../master/services";
import { PortalAppNotificationsComponent } from "./portal-app-notifications/portal-app-notifications.component";
import { PortalAppBatchRegistrationComponent } from "./portal-app-batch-registration/portal-app-batch-registration.component";
import { StaffPortalAppRegComponent } from "./staff-portal-app-reg/staff-portal-app-reg.component";
import { StudentPortalAppRegComponent } from "./student-portal-app-reg/student-portal-app-reg.component";
import { ParentPortalAppRegComponent } from "./parent-portal-app-reg/parent-portal-app-reg.component";
import { PanicAlertTopicMaintenanceComponent } from "./panic-alert-topic-maintenance/panic-alert-topic-maintenance.component";
import { PortalAppNotificationLogComponent } from "./portal-app-notification-log/portal-app-notification-log.component";
import { PanicAlertMaintenanceComponent } from "./panic-alert-maintenance/panic-alert-maintenance.component";

export const PortalAppsRoutes: Routes = [
	{
		path: "parentportalappreg",
		data: { title: "Parent Portal Registration" },
		component: ParentPortalAppRegComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "studentportalappreg",
		data: { title: "Student Portal Registration" },
		component: StudentPortalAppRegComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "staffportalappreg",
		data: { title: "Staff Portal Registration" },
		component: StaffPortalAppRegComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "portalappbatchregistration",
		data: { title: "Batch Registration" },
		component: PortalAppBatchRegistrationComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "portalappnotifications",
		data: { title: "Send Notifications" },
		component: PortalAppNotificationsComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "notificationlog",
		data: { title: "Notification Log" },
		component: PortalAppNotificationLogComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "panicalerttopics",
		data: { title: "School-Based Alert Topics" },
		component: PanicAlertTopicMaintenanceComponent,
		canActivate: [AuthguardService],
	},
	{
		path: "panicalertmaintenance",
		data: { title: "School-Based Maintenance" },
		component: PanicAlertMaintenanceComponent,
		canActivate: [AuthguardService],
	},
	// {
	// 	path: "notifystaff",
	// 	data: { title: "Notify Staff" },
	// 	component: PortalAppsComponent,
	// 	canActivate: [AuthguardService],
	// },
];
